module.exports = __webpack_public_path__ + "static/img/1.a66515e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/bodyfriend/1.png
// module id = z9dk
// module chunks = 1